export const ASSETS_ADD_JS = 'ASSETS_ADD_JS';
export const ASSETS_ADD_CSS = 'ASSETS_ADD_CSS';

export function addAsset(type, uri, parentTag) {
  switch (type) {
    case 'js':
      return {
        parentTag,
        type: ASSETS_ADD_JS,
        uri
      };
    case 'css':
      return {
        parentTag,
        type: ASSETS_ADD_CSS,
        uri
      };
    default:
      return {};
  }
}
